import {ApiFilter} from './ApiFilter';
import _ from "lodash";

export class RawFilter extends ApiFilter {
    static parse(object) {
        return new RawFilter(object.filter);
    }

    filter: { [key: string]: any };

    constructor(filter: { [key: string]: any }) {
        super('raw');
        this.filter = filter;
    }

    toPlainObject() {

        if (_.isEmpty(this.filter)) {
            throw new Error('filter is mandatory')
        }
        const result: any = super.toPlainObject();
        result.filter = this.filter;
        return result;
    }

    getCopy(): ApiFilter {
        const apiFilter = new RawFilter(this.filter.getCopy());
        return apiFilter
    }
}